module.exports = __webpack_public_path__ + "img/home_slide2.6e3ffbe6.jpg";